
import { ElMessage } from "element-plus";
import { Saih } from "@/types/saih.type";
import { AppError } from "@/types/app.type";
import { defineComponent } from "@vue/runtime-core";
import { Container } from "@/types/container.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { postSaih } from "@/service/saih.service";

const errorMessage = "error.required";

export default defineComponent({
  components: {},
  props: {
    id: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      saihForm: {} as Saih,
      containersSaihs: [] as Container[],
      sampPointSaihs: [] as SamplingPoint[],
      containerId: null,
      rules: {
        name: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        code: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        river: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        utmX: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        utmY: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        timeZone: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        municipality: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        province: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        confederation: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
      },
    };
  },

  methods: {
    async doSave() {
      if (
        this.saihForm.name === undefined ||
        this.saihForm.code === undefined ||
        this.saihForm.river === undefined ||
        this.saihForm.utmX === undefined ||
        this.saihForm.utmY === undefined ||
        this.saihForm.timeZone === undefined ||
        this.saihForm.municipality === undefined ||
        this.saihForm.province === undefined ||
        this.saihForm.confederation === undefined
      ) {
        ElMessage.error(this.$t(errorMessage));
        throw new Error(AppError.FORM_VALIDATION);
      }

      return postSaih(this.saihForm);
    },
  },
});
